"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" fill=none id=icon-spinner-20><path d="M15 8a7 7 0 1 1-8.657-6.801" stroke-width=2 stroke-linecap=round stroke-linejoin=round stroke="var(--color-spinner-icon-background, #3665F3)"></path><path d="M9.738 1.22a7 7 0 0 1 4.574 3.754" stroke-width=2 stroke-linecap=round stroke-linejoin=round stroke="var(--color-spinner-icon-foreground, #E5E5E5)"></path></symbol>';
}
